function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_21",
  "data-name": "Group 21",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_67",
  "data-name": "Path 67",
  d: "M0,0H10.256V222.958H0Z",
  transform: "translate(42.631 48.27) rotate(-2.178)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_68",
  "data-name": "Path 68",
  d: "M74.245,58.044A55.584,55.584,0,0,0,32.787,124.83,55.584,55.584,0,0,0,74.245,58.044Z",
  transform: "translate(25.823 109.24)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_69",
  "data-name": "Path 69",
  d: "M16.473,59.107A55.584,55.584,0,0,1,62.9,122.539,55.584,55.584,0,0,1,16.472,59.107Z",
  transform: "translate(-11.719 111.815)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  "data-name": "Path 70",
  d: "M73.647,42.377a55.584,55.584,0,0,0-41.458,66.786A55.584,55.584,0,0,0,73.647,42.377Z",
  transform: "translate(24.375 71.299)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M15.875,43.44A55.584,55.584,0,0,1,62.3,106.873,55.584,55.584,0,0,1,15.875,43.44Z",
  transform: "translate(-13.167 73.873)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M73.049,26.711A55.584,55.584,0,0,0,31.591,93.5,55.584,55.584,0,0,0,73.049,26.71Z",
  transform: "translate(22.927 33.357)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  "data-name": "Path 73",
  d: "M41.344,9.156h0C14.334,33.938,16.31,71.933,45.758,94.021,72.767,69.239,70.791,31.244,41.344,9.156Z",
  transform: "translate(4.026 -9.156)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M15.277,27.774A55.584,55.584,0,0,1,61.7,91.206,55.584,55.584,0,0,1,15.277,27.774Z",
  transform: "translate(-14.615 35.931)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M0,0H10.256V222.958H0Z",
  transform: "translate(234.041 180.285) rotate(55.881)",
  fill: "#65ccb8"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_22",
  "data-name": "Group 22",
  transform: "translate(76.052 152.738)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  "data-name": "Path 76",
  d: "M117.975,105.936a55.584,55.584,0,0,0-78.608.119,55.584,55.584,0,0,0,78.608-.119Z",
  transform: "translate(-30.721 33.203)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_77",
  "data-name": "Path 77",
  d: "M70.615,71.374a55.584,55.584,0,0,1-29.3,72.944,55.584,55.584,0,0,1,29.3-72.945Z",
  transform: "translate(-36.84 -11.216)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  "data-name": "Path 78",
  d: "M130.957,97.145a55.584,55.584,0,0,0-78.608.119,55.584,55.584,0,0,0,78.608-.119Z",
  transform: "translate(0.719 11.915)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_79",
  "data-name": "Path 79",
  d: "M83.6,62.583a55.584,55.584,0,0,1-29.3,72.945A55.584,55.584,0,0,1,83.6,62.583Z",
  transform: "translate(-5.4 -32.504)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_80",
  "data-name": "Path 80",
  d: "M143.939,88.355a55.584,55.584,0,0,0-78.608.119,55.584,55.584,0,0,0,78.608-.119Z",
  transform: "translate(32.159 -9.374)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  d: "M144.716,56.71h0C109.4,46.885,78.2,68.65,75.016,105.323,110.331,115.148,141.537,93.382,144.716,56.71Z",
  transform: "translate(55.612 -52.441)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  d: "M96.579,53.793a55.584,55.584,0,0,1-29.3,72.944,55.584,55.584,0,0,1,29.3-72.945Z",
  transform: "translate(26.04 -53.793)",
  fill: "#65ccb8"
}));

function SvgWheatselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wheatselected",
    xmlns: "http://www.w3.org/2000/svg",
    width: 276.381,
    height: 313.856,
    viewBox: "0 0 276.381 313.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheatselected);
export default __webpack_public_path__ + "static/media/wheatselected.e0144faf.svg";
export { ForwardRef as ReactComponent };